import React from "react";
import JBKycDocumentsComponent from "./JBKycDocumentsComponent";
import JBProofUploadComponent from "./JBProofUploadComponent";
import NIBiddingApplicationForm from "../NIBiddingApplicationForm";
import NITermsAndConditions from "../NITermsAndConditions";
import JBCompletedStepsComponent from "./JBCompletedStepsComponent";
import KycDocumentsUploadComponent from "../IndividualBidders/KycDocumentsUploadComponent";
import JBApproverDetailsForm from "./JBApproverDetailsForm";
import JBBidderBidApplicationDownloadComponent from "./JBBidderBidApplicationDownloadComponent";

interface JointIndividualOfflinePrimaryKycStepContentProps {
  activeStep: number;
  bidderUuid: any;
  bidder: any;
  setActiveStep: any;
  init: any;
  offlinePaymentValidation: boolean;
  stepsTitles: Array<{ label: string; value: string }>;
  requiresApproverDetails?: boolean;
}

export default function JointIndividualOfflinePrimaryKycStepContent({
  activeStep,
  bidderUuid,
  bidder,
  setActiveStep,
  init,
  offlinePaymentValidation,
  stepsTitles,
  requiresApproverDetails = true,
}: JointIndividualOfflinePrimaryKycStepContentProps) {
  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <KycDocumentsUploadComponent
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            bidderUuid={bidderUuid}
            bidder={bidder}
            init={init}
          />
        );
      case 1:
        return (
          <JBProofUploadComponent
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 2:
        return (
          <NIBiddingApplicationForm
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            bidder={bidder}
            outerNextStep="bid_details"
          />
        );
      case 3:
        return (
          <NITermsAndConditions
            bidderUuid={bidderUuid}
            bidder={bidder}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep={"t_&_c"}
          />
        );
      case 4:
        return (
          <JBBidderBidApplicationDownloadComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep={
              requiresApproverDetails ? "bid_application_download" : "completed"
            }
            requiresApproverDetails={requiresApproverDetails}
          />
        );
      case 5:
        return requiresApproverDetails ? (
          <JBApproverDetailsForm
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep="approver_details"
            outerVerificationStep="wait_for_consent"
          />
        ) : (
          <JBCompletedStepsComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 6:
        return (
          <JBCompletedStepsComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="p-2 md:p-4 bg-white">
      {activeStep !== 2 && (
        <div className="flex flex-col sm:flex-row justify-end gap-2">
          <div className="flex items-center flex-wrap text-[10px] sm:text-xs">
            <span className="text-brand-orange font-semibold">Offline KYC</span>
            <span className="text-gray-500 font-semibold pl-1">
              → Final bid application must be submitted at the bank.
            </span>
          </div>
        </div>
      )}
      {renderStepContent()}
    </div>
  );
}
